/** @format */

import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import * as React from 'react';

interface Props {
  status: string;
  /** Shown under the spinner when status is loading (e.g. document name during upload). */
  message?: string;
}
export default function SimpleBackdrop({ status, message }: Props) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (status === 'loading') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [status]);

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}>
          <CircularProgress color="inherit" />
          {message ? (
            <Typography
              variant="body2"
              component="p"
              sx={{
                textAlign: 'center',
                maxWidth: 'min(90vw, 420px)',
                px: 2,
                lineHeight: 1.4,
              }}>
              {message}
            </Typography>
          ) : null}
        </Box>
      </Backdrop>
    </div>
  );
}
